import { AcquiringOperationsService } from "./../../../services/documents/AcquiringOperationsService";
import React from "react";
import { AcquiringOperationsDetail } from "../../../components/Pages/Documents/AcquiringOperations/AcquiringOperationsDetail";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateAcquiringOperationsDto } from "../../../dtos/documents/AcquiringOperations/CreateAcquiringOperationsDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupAcquiringOperations } from "../../../components/Shared/NewForms/NFLookupAcquiringOperations";
import AcquiringOperationsList from "../../../components/Pages/Documents/AcquiringOperations/AcquiringOperationsList";

export const AcquiringOperations: IAppEntity = {
  entityType: "document",
  title: "Acquiring Operations",
  pluralTitle: "Acquiring Operations",
  apiUrl: "AcquiringOperations",
  apiEnum: ReferenceTypes.DocumentAcquiringOperation,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(AcquiringOperationsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(AcquiringOperationsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupAcquiringOperations, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new AcquiringOperationsService("AcquiringOperations"),
  getEmptyModel: () => {
    const model: CreateAcquiringOperationsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      documentNumber: "",
      documentDate: new Date(),
      
      createdDate: new Date(),
      
    };
    return model;
  },
};
